import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedLiabilityInsuranceDocument,
  RemoveLiabilityInsuranceMutation,
  RemoveLiabilityInsuranceMutationVariables,
  RemoveLiabilityInsuranceDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for removing a liability insurance and handling the necessary cache updates.
 * @returns {Object} - Contains the removeLiabilityInsuranceMutation function, loading state, and error state.
 */
export default function useRemoveLiabilityInsuranceMutationHook(): {
  removeLiabilityInsuranceMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeLiabilityInsuranceMutation, { loading, error }] = useMutation<RemoveLiabilityInsuranceMutation, RemoveLiabilityInsuranceMutationVariables>(
    RemoveLiabilityInsuranceDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedLiabilityInsurance");

        toast(CustomToastComponent, {
          toastId: "liability-insurance-removed-success",
          data: {
            title: t("toasts.liabilityinsuranceremovedsuccessfully"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: PaginatedLiabilityInsuranceDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              activeFrom: null,
              liabilityInsurance: null,
              professionalAssociation: null,
            },
            sort: null,
          },
        },
      ],
    });

  return {
    removeLiabilityInsuranceMutation,
    loading,
    error,
  };
}
